<template>
  <v-row>
    <v-col cols="12" lg="3" md="6" sm="6">
      <card-widget
        icon="mdi-currency-usd"
        label="Transaction Value"
        :value="loadingData ? 0 : summaryReport.sales.todayRevenue"
        type="string"
      ></card-widget>
    </v-col>

    <v-col cols="12" lg="3" md="6" sm="6">
      <card-widget
        icon="mdi-cash-100"
        label="MTD Transaction Value"
        :value="loadingData ? 0 : summaryReport.sales.monthDateRevenue"
        type="string"
      ></card-widget>
    </v-col>

    <v-col cols="12" lg="3" md="6" sm="6">
      <card-widget
        icon="mdi-bell-ring"
        label="Active Account"
        :value="loadingData ? 0 : summaryReport.sales.activeTotal"
        type="string"
      ></card-widget>
    </v-col>

    <v-col cols="12" lg="3" md="6" sm="6">
      <card-widget
        icon="mdi-account-arrow-up-outline"
        label="Dormant Account"
        :value="loadingData ? 0 : summaryReport.sales.dormantAccount"
        link="dormant-list"
        type="string"
      ></card-widget>
    </v-col>

    <v-col cols="12" lg="3" md="6" sm="6">
      <card-widget
        icon="mdi-account-clock-outline"
        label="Pending for installation"
        :value="loadingData ? 0 : summaryReport.installation.total"
        link="pending-for-installation-list"
        type="string"
      ></card-widget>
    </v-col>

    <!-- <v-col cols="12" lg="3" md="6">
      <card-widget
        icon="mdi-file-sign"
        label="Sign-up pending payment"
        :value="loadingData ? 0 : summaryReport.noNap.total"
        link="view-todays-revenue"
      ></card-widget>
    </v-col> -->

    <v-col cols="12" lg="3" md="6" sm="6">
      <card-widget
        icon="mdi-file-sign"
        label="Today's Sign-up"
        :value="loadingData ? 0 : summaryReport.noNap.today"
        link="today-signup-list"
        type="string"
      ></card-widget>
    </v-col>

    <v-col cols="12" lg="3" md="6" sm="6">
      <card-widget
        icon="mdi-calendar-today"
        label="Today's Activations"
        :value="loadingData ? 0 : summaryReport.active.today"
        link="today-activation-list"
        type="string"
      ></card-widget>
    </v-col>

    <v-col cols="12" lg="3" md="6" sm="6">
      <card-widget
        icon="mdi-calendar-month"
        label="MTD Activations"
        :value="loadingData ? 0 : summaryReport.active.month"
        link="month-activation-list"
        type="string"
      ></card-widget>
    </v-col>
  </v-row>
</template>

<script>
import CardWidget from "../../../../components/CardWidget.vue";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  name: "SummaryReport",
  mixins: [ShareableMethods],
  data() {
    return {
      summaryReport: {},
      loadingData: true,
    };
  },

  components: {
    CardWidget,
  },

  methods: {
    async getSummaryReport() {
      await this.$api
        .get("/acquisition/report?report=home")
        .then((response) => {
          const data = response.data.data;

          this.summaryReport = data;
          this.loadingData = false;

          data.forInstallation = data.installation.total;
          data.payLater = data.paylater.total;

          this.$store.dispatch("addDealerSummaryReport", data);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },

  created() {
    this.getSummaryReport();
  },

  computed: {
    // userRole() {
    //   return this.$store.getters.userRole;
    // },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
